module.exports = __webpack_public_path__ + "static/media/logo.82508ef3.svg";